import { useState, ReactNode } from "react";
import { useSigningTranslations } from "@/modules/signing/shared/utils/use-signing-translations";
import Button from "@/shared/form/button";
import { useSigningWithNCALayer } from "../model/use-signing-with-ncalayer";

export function BaseSignWithNCALayerButton({
  docs,
  onSign,
  loading = false,
  children,
  disabled,
}: {
  docs: string[];
  onSign: (signatures: string[]) => Promise<void>;
  loading?: boolean;
  children?: ReactNode;
  disabled?: boolean;
}) {
  const t = useSigningTranslations();
  const { sign } = useSigningWithNCALayer();
  const [isSigning, setIsSigning] = useState(false);

  const handleSign = async () => {
    setIsSigning(true);
    try {
      const signatures = [];
      for (const doc of docs) {
        const signature = await sign(doc);

        if (!signature) {
          return;
        }

        signatures.push(signature);
      }

      await onSign(signatures);
    } finally {
      setIsSigning(false);
    }
  };

  return (
    <Button
      block
      loading={loading || isSigning}
      disabled={disabled}
      onClick={handleSign}
    >
      {children ?? t("Sign with NCALayer")}
    </Button>
  );
}
